var FadeSupport                 = require("enyo-ui/FadeSupport"),
    FitToScrollerSupport        = require("enyo-ui/FitToScrollerSupport"),
    Layout                      = require("./MediaDetailsPopupLayout"),
    Scrim                       = require("enyo-ui/Scrim"),
    Scroller                    = require("enyo-ui/Scroller"),
    ScrollerDecoratorScrollbars = require("app/ui/ScrollerDecoratorScrollbars"),
    ScrollerPopup               = require("app/ui/ScrollerPopup"),
    Spinner                     = require("app/ui/Spinner"),
    ViewContainerSupport        = require("app/core/ViewContainerSupport"),
    kind                        = require("enyo/kind");

require("app/ui/Scrim.less");
require("./MediaDetailsPopup.less");

module.exports = kind(/** @lends  app.AppLayout.MediaDetailsPopup.prototype */ {

    /**
     * @private
     */
    name: "app.AppLayout.MediaDetailsPopup",

    /**
     * @private
     */
    kind: ScrollerPopup,

    /**
     * @private
     */
    layoutKind: Layout,

    /**
     * @private
     */
    classes: "app-app-layout-media-details-popup",

    /**
     * @private
     */
    scrimOptions: {
        classes: "app-app-layout-media-details-popup__scrim app-ui-scrim"
    },

    /**
     * @private
     */
    loadingGraphicRequests: 0,

    /**
     * Sets layout height. Can be used by other components to align content
     * below the metadata.
     *
     * @type {Object}
     * @readonly
     * @public
     */
    layoutMetrics: null,

    /**
     * @private
     */
    formFactor: "wide",

    /**
     * @private
     */
    windowComponents: [{
        name:               "scrollerDecorator",
        kind:               ScrollerDecoratorScrollbars,
        classes:            "app-app-layout-media-details-popup__scroller-decorator",
        scrollerPath:       ".owner.$.scroller",
        fadeChromeOnScroll: true,
        components:         [{
            name:           "scroller",
            kind:           Scroller,
            classes:        "app-app-layout-media-details-popup__scroller",
            vertical:       true,
            horizontal:     false,
            scrollChaining: false,
            maxWidth:       "100%",
            components:     [{
                name:   "client",
                mixins: [
                    FitToScrollerSupport,
                    ViewContainerSupport
                ],
                classes:      "app-app-layout-media-details-popup__client",
                scrollerPath: ".owner.$.scroller"
            }]
        }]
    }, {
        name:               "innerScrim",
        kind:               Scrim,
        floating:           false,
        classes:            "app-app-layout-media-details-popup__inner-scrim app-ui-scrim",
        showing:            false,
        initialOpacity:     0,
        usePerformanceMode: true
    }, {
        name:               "spinner",
        kind:               Spinner,
        classes:            "app-app-layout-media-details-popup__spinner",
        mixins:             [FadeSupport],
        showing:            false,
        initialOpacity:     0,
        usePerformanceMode: true
    }],

    /**
     * @private
     */
    observers: {
        resize: ["formFactor"]
    },

    /**
     * The usual 'close' function simply hides the popup. In our case, this
     * particular popup is always opened by navigating to a url that requires
     * the popup to be shown.
     *
     * In mobile view, this popup fills the entire content area and behaves like
     * a normal page. The only way to close it is by navigating away from it.
     *
     * On desktop, we should keep this behavior the same. As such, the proper
     * way to close this popup is to navigate away from that url.
     *
     * @public
     */
    close: function() {
        this.controller.triggerHandler("onRequestClose");
    },

    // Loading Graphic Visibility
    // --------------------------------

    /**
     * Request that the loading graphic gets shown.
     *
     * @public
     */
    requestShowLoadingGraphic: function() {
        this.set("loadingGraphicRequests", this.loadingGraphicRequests + 1);
    },

    /**
     * Request that the loading graphic gets hidden.
     *
     * @public
     */
    requestHideLoadingGraphic: function() {
        this.set("loadingGraphicRequests", this.loadingGraphicRequests - 1);
    },

    /**
     * Shows the loading graphic if it was requested at least once. Hides the
     * loading graphic again once all previous requests have been withdrawn.
     *
     * @param {number}  oldCount  The previous amount of requests for a
     *                            loading graphic.
     * @private
     */
    loadingGraphicRequestsChanged: function(oldCount) {
        var currentCount = this.loadingGraphicRequests,
            innerScrim   = this.$.innerScrim,
            spinner      = this.$.spinner;

        if (currentCount > 0 && oldCount === 0) {
            innerScrim.requestShow(true, false);
            spinner.show(true, false);
        }

        if (currentCount === 0 && oldCount > 0) {
            innerScrim.requestHide(true, false);
            spinner.hide(true, false);
        }
    }

});
